"use strict";

var _ = require("underscore");


/*
 * Factory to organize multiple instances of actions and stores by a key (instanceKey).
 * This is useful when a component is using actions/stores and need to be reused
 * on the same page.
 * @author Julio, Tulio
*/
module.exports.factory = function (instanceCreator) {
  var instances = {};

  return function (instanceKey) {
    if (!instances[instanceKey]) {
      instances[instanceKey] = instanceCreator(instanceKey);
    }
    return instances[instanceKey];
  };
};


/*
 * Set an action or store instance based on the key defined in props.instanceKey.
 *
 * The component should have:
 * - Method getActionsAndStores that returns a key-value obj where the key is the attribute name
 * and the value is the action/store factory
 * - Prop instanceKey
 * @author Julio, Tulio
*/
module.exports.mixin = {
  propTypes: {
    instanceKey: React.PropTypes.string.isRequired
  },
  getInitialState: function () {
     this.setActionsAndStores();
    return null;
  },
  setActionsAndStores: function(){
    var storesAndActions = this.getActionsAndStores();
    _.each(storesAndActions, function(storeOrAction, key){
      if(!this[key]) {
        this[key] = storeOrAction(this.props.instanceKey);
      }
    }.bind(this));
  }
};



// WEBPACK FOOTER //
// ./app/util/flux/multi-action-store.js